// extracted by mini-css-extract-plugin
export default {"dentalChart":"DentalChart_dentalChart__fdYW8","row":"DentalChart_row__PrqYW"};